module.exports = "/images/sub-argument.png?5ec0ebeb7ee88c85e92cdb163177991a";